/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SetAmountRequest} from '@cash-web/protos/squareup/franklin/app/amount.pb'
import {SetAmountResponse} from '@cash-web/protos/squareup/franklin/app/amount.pb'


export const setAmount = (request: SetAmountRequest, options?: CashRequestOptions) => post<SetAmountRequest, SetAmountResponse>("/2.0/cash/set-amount", request, {...options, rejectOnError: true })